import Alpine from 'alpinejs';

Alpine.data('select', (name, value) => ({
  isOpen: false,
  availableFilters: [],
  placeholder: '',
  filters: '',
  name,
  init(filters, placeholder) {
    if (filters && JSON.parse(filters)) {
      const filts = JSON.parse(filters);

      this.availableFilters = filts;

      // const filter = filts.filters
      //   ? Object.keys(filts.filters).find((name) => {
      //       if (name.includes('_')) {
      //         return name.split('_')[1] === this.taxonomy.trim().split('_')[1];
      //       }

      //       return name === this.taxonomy;
      //     })
      //   : null;

      // if (filter) {
      //   this.filters = filts.filters[filter];
      // }
    }

    if (placeholder) {
      this.placeholder = placeholder;
    }

    if (value) {
      this.filters = value;
    }
  },
  getFilterName() {
    const filter = this.availableFilters.find(
      (filter) => filter.value == this.filters
    );

    if (filter) return filter.title;

    if (this.placeholder) return this.placeholder;
  },

  handleSelect(value) {
    if (this.filters === value) {
      this.filters = '';
      this.$dispatch('filters-query', {
        name: this.name,
        by: '',
      });
      return;
    }

    this.filters = value;

    this.availableFilters.find((filter) => filter.value === this.filters);

    this.$dispatch('filters-query', {
      by: value,
      name: this.name,
    });
  },
}));
